import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'triggered-terms-and-conditions-view',
  templateUrl: './terms-and-conditions.view.html',
  styleUrls: ['./terms-and-conditions.view.scss']
})
export class TermsAndConditionsView implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
